//Importing modules
import React, { useReducer } from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import axios from "axios"
import { CircularProgress } from '@material-ui/core';
import {decisionReducer} from "../../../../Utils/requestUtils"
import {getConfirmationIconDialog} from "../../../utils/utils"



//Defining DeleteListDialog component
function SharedListPermissionEditionDialog(props) {
    //Extracting data from props
    let {sharedListPermissions, list_key, setReloadSharedListPermissionsTable, onClose, companyKey, userData} = props


    //Making request to dash API 
    const [dialogState, dispatchDialogState] = useReducer(
        decisionReducer,
        {isLoading: false, isError: false, finished:false}
    )


    //Defining function to handle Dash API request on confirmation button press
    const handleConfirm = () =>{
        let editedPermissions = sharedListPermissions.reduce((acc,item) => {
            if ((item.edit_can_read === true && item.can_read === true) || (item.edit_can_write === true && item.can_write === true)) {
                let editedPermission = {
                    "company_key": item.company_key,
                    "can_read": item.can_read,
                    "can_write": item.can_write
                }
                acc = [...acc, editedPermission]
            }
            return acc
        },[])
        let payload=  { "shared_list_permissions": editedPermissions}
        dispatchDialogState({type:"send_request_init"})
        let requestHeaders = {headers:{}}
        if (userData.business_group_key) {
            requestHeaders = {headers:{company_key:companyKey}}
        }
        setTimeout(function () {
            axios.put('/dash/lists/' + list_key +'/shared_list_permission', payload, requestHeaders).then(response => {
                dispatchDialogState({type:"send_request_success"})
              }).catch(error => {
                if ((error.response || {}).status === 403) dispatchDialogState({type: "send_request_failure_403"})
                else if ((error.response || {}).status === 409) dispatchDialogState({type: "send_request_failure_409"})  
                else dispatchDialogState({type: "send_request_failure"})    
              });
        }, 1000);
    }

    if (dialogState.finished && dialogState.isLoading){
        return (
            <Dialog 
                open={props.open} 
                onClose={onClose}
                keepMounted={false}
                disableBackdropClick
                disableEscapeKeyDown
            >
                <DialogTitle style={{paddingBottom: "0px"}} className={["blueText", "normalMediumSize"].join(" ")}>Confirmação de Revisão</DialogTitle>
                <DialogContent>
                    <div style={{display:"flex", width: "310px", height:"217px"}}>
                        <CircularProgress style={{margin:"auto"}} />
                    </div>
                </DialogContent>
            </Dialog>
        )
    }
    else if (dialogState.finished){
        let confirmationData = {    
            message: dialogState.message,
            success: !dialogState.isError
        }
        return (
            <Dialog 
                open={props.open} 
                onClose={onClose}                 
                keepMounted={false}
                disableBackdropClick
            >
                <DialogTitle style={{paddingBottom: "0px"}} className={["blueText", "normalMediumSize"].join(" ")}>Confirmação de Revisão</DialogTitle>
                <DialogContent>
                <div style={{width: "310px", height:"217px"}}>
                    <div className="internalCardContainer" style={{display:"flex", height:"40%", justifyContent:"center"}}>
                        {getConfirmationIconDialog(confirmationData.success)}
                    </div>
                    <div className="internalCardContainer" style={{display:"flex", textAlign:"center", justifyContent:"center"}}>
                        {confirmationData.message}
                    </div>
                    <div className="internalCardContainer" style={{display:"flex", justifyContent:"center"}}>
                        <div 
                            className={["button", "standard", "normalText", "normalMediumSize"].join(" ")}
                            onClick={() => {
                                onClose()
                                setReloadSharedListPermissionsTable(true)
                            }} 
                        >
                            VOLTAR À TELA INICIAL 
                        </div>
                    </div>
                </div>
                </DialogContent>
            </Dialog>
        )
    }
    else {
        return (
            <Dialog 
            open={props.open} 
            onClose={onClose} 
            keepMounted={false}
            >
                <DialogTitle style={{paddingBottom: "0px"}} className={["blueText", "normalMediumSize"].join(" ")}>Confirmação de Revisão</DialogTitle>
                <DialogContent>
                    <div 
                        style={{width:"310px", height: "120px", display:"flex", flexDirection:"column", alignItems:"center"}}
                    >
                        <div 
                            className={["internalCardContainer", "normalText", "normalMediumSize"].join(" ")} 
                            style={{width:"90%", textAlign:"center"}}>
                            Tem certeza que deseja atribuir estas permissões? 
                        </div>
                        <div className="internalCardContainer" style={{display:"flex", marginTop: "10px"}}>
                            <div
                                className={["button", "onlyboarder", "normalText", "normalMediumSize"].join(" ")}
                                style={{width:"120px", fontWeight:"600"}}
                                onClick={props.onClose}
                            >
                                Cancelar
                            </div>
                            <div
                                className={["button", "reproved", "normalText", "normalMediumSize"].join(" ")}
                                style={{width:"120px", fontWeight:"600", paddingTop:"7px"}}
                                onClick={handleConfirm}
                            >
                                Confirmar
                            </div>   
                        </div>
                    </div>
              </DialogContent>
            </Dialog>
        )   
    }
}


export default SharedListPermissionEditionDialog;